import React from 'react';

const DEFAULT_ICON_SIZE = { w: 26, h: 24 };

type Props = {
  w?: number;
  h?: number;
  className?: string;
};

const MetamaskIcon = ({ className, w, h }: Props): JSX.Element => {
  return (
    <svg
      width={w || DEFAULT_ICON_SIZE.w}
      height={h || DEFAULT_ICON_SIZE.h}
      viewBox="0 0 26 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        fillRule="nonzero"
        strokeWidth=".5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="#E17726" fill="#E17726" d="m23.813 1-9.376 6.875 1.744-4.052z" />
        <g fill="#E27625" stroke="#E27625">
          <path d="m2.187 1 9.292 6.94-1.66-4.117zM20.437 16.94l-2.494 3.777 5.341 1.458 1.53-5.152zM1.195 17.023l1.52 5.152 5.333-1.457-2.485-3.777z" />
          <path d="m7.76 10.56-1.483 2.22 5.286.238-.177-5.638zM18.24 10.56l-3.682-3.244-.12 5.702 5.285-.239zM8.048 20.718l3.2-1.531-2.755-2.127zM14.753 19.187l3.19 1.53-.436-3.657z" />
        </g>
        <g fill="#D5BFB2" stroke="#D5BFB2">
          <path d="m17.943 20.718-3.19-1.531.26 2.053-.028.87zM8.048 20.718l2.967 1.393-.018-.871.25-2.053z" />
        </g>
        <path
          stroke="#233447"
          fill="#233447"
          d="m11.071 15.703-2.652-.77 1.873-.852zM14.929 15.703l.779-1.622 1.882.852z"
        />
        <g fill="#CC6228" stroke="#CC6228">
          <path d="m8.048 20.718.464-3.777-2.95.082zM17.488 16.94l.455 3.778 2.494-3.695zM19.723 12.78l-5.286.238.492 2.685.779-1.622 1.882.852zM8.419 14.933l1.873-.852.78 1.622.49-2.685-5.285-.239z" />
        </g>
        <g fill="#E27525" stroke="#E27525">
          <path d="m6.277 12.78 2.216 4.28-.074-2.127zM17.59 14.933l-.083 2.127 2.216-4.28zM11.563 13.018l-.492 2.685.621 3.172.14-4.18zM14.437 13.018l-.26 1.668.13 4.189.622-3.172z" />
        </g>
        <path
          stroke="#F5841F"
          fill="#F5841F"
          d="m14.929 15.703-.621 3.172.445.312 2.754-2.127.083-2.127zM8.419 14.933l.074 2.127 2.754 2.127.445-.312-.62-3.172z"
        />
        <path
          stroke="#C0AC9D"
          fill="#C0AC9D"
          d="m14.985 22.11.027-.87-.24-.202h-3.543l-.232.202.018.87-2.967-1.392 1.039.843L11.192 23h3.607l2.114-1.44 1.03-.842z"
        />
        <path
          stroke="#161616"
          fill="#161616"
          d="m14.753 19.187-.445-.312h-2.616l-.445.312-.25 2.053.232-.202h3.542l.241.202z"
        />
        <g fill="#763E1A" stroke="#763E1A">
          <path d="M24.212 8.324 25 4.53 23.813 1l-9.06 6.646 3.487 2.915 4.924 1.42 1.085-1.255-.473-.34.751-.678-.575-.44.751-.568zM1 4.53l.798 3.794-.51.376.76.568-.575.44.751.679-.473.339 1.085 1.256L7.76 10.56l3.487-2.915L2.187 1z" />
        </g>
        <path
          stroke="#F5841F"
          fill="#F5841F"
          d="M23.164 11.982 18.24 10.56l1.483 2.218-2.216 4.281 2.93-.037h4.378zM7.76 10.56l-4.924 1.422-1.641 5.041h4.368l2.93.037-2.216-4.28zM14.437 13.018l.316-5.372 1.428-3.823H9.819l1.428 3.823.316 5.372.12 1.686.01 4.171h2.615l.009-4.17z"
        />
      </g>
    </svg>
  );
};

MetamaskIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default MetamaskIcon;
